import Home from '../components/pages/Home.vue'
import Inbox from '../components/pages/Inbox.vue'
import KycPage from '../components/pages/KycPage.vue'
import Performance from '../components/pages/Performance.vue'
import Profile from '../components/pages/Profile.vue'
import Shop from '../components/pages/Shop.vue'
import MyPurchases from '../components/pages/MyPurchases.vue'
import Withdrawals from '../components/pages/Withdrawals.vue'
import authRoutesMap from './auth/authRoutesMap'

export default {
  ...authRoutesMap,
  home: {
    route: '/',
    name: 'home',
    title: 'home',
    component: Home,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  profile: {
    route: '/profile',
    name: 'profile',
    title: 'profile',
    component: Profile,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  inbox: {
    route: '/inbox',
    name: 'inbox',
    title: 'inbox',
    component: Inbox,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  kyc: {
    route: '/kyc',
    name: 'kyc',
    title: 'kyc',
    component: KycPage,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  performance: {
    route: '/performance',
    name: 'performance',
    title: 'performance',
    component: Performance,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  withdrawals: {
    route: '/withdrawals',
    name: 'withdrawals',
    title: 'withdrawals',
    component: Withdrawals,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  shop: {
    route: '/shop',
    name: 'shop',
    title: 'shop',
    component: Shop,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
  myPurchases: {
    route: '/mes-achats',
    name: 'myPurchases',
    title: 'Mes achats',
    component: MyPurchases,
    layoutName: 'app',
    checkAuth: true,
    needAuth: true,
  },
}
